import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../hooks/AuthContext";
import Loading from "../components/Loading";

const AdminRoute = ({ children }: { children: React.JSX.Element }) => {
  const { isAdmin, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return <Loading />;
  }

  return isAdmin ? children : <Navigate to="/login" />;
};

export default AdminRoute;
